// Vorlagen: freie Prototyp-Vorlagen (specVersion 2) und die 8 MVP-Zonenvorlagen (specVersion 1, DQ-STU-002).
import { WIDGET_TYPES } from './render.js';
/** Neues Element mit den Vorgaben des Bausteins (wie T() im Prototyp). */
export function createElement(type, x, y, w, h, extra = {}) {
    return { type, x, y, w, h, ...structuredClone(WIDGET_TYPES[type].defaults), ...extra };
}
const T = createElement;
/** Vorlagen für geteilte Bildschirme (Prototyp-Designer). Jede liefert neue Elemente. */
export const TEMPLATES = {
    Vollbild: () => [T('image', 0, 0, 100, 100)],
    'Geteilt 50/50': () => [T('image', 0, 0, 50, 100), T('image', 50, 0, 50, 100)],
    'Hauptbereich + Seitenleiste': () => [
        T('slideshow', 0, 0, 70, 100),
        T('clock', 70, 0, 30, 30, { bg: '#111111' }),
        T('weather', 70, 30, 30, 35, { bg: '#1a1a1a', size: 6.5 }),
        T('text', 70, 65, 30, 35, { bg: '#c8102e', text: 'Probetraining\nkostenlos', size: 5 }),
    ],
    'Mit Laufschrift unten': () => [T('slideshow', 0, 0, 100, 90), T('ticker', 0, 90, 100, 10)],
    '4er-Raster': () => [
        T('image', 0, 0, 50, 50),
        T('image', 50, 0, 50, 50),
        T('image', 0, 50, 50, 50),
        T('image', 50, 50, 50, 50),
    ],
    'Studio-Infoscreen': () => [
        T('slideshow', 0, 0, 68, 90),
        T('clock', 68, 0, 32, 22, { bg: '#111111', size: 8 }),
        T('weather', 68, 22, 32, 26, { bg: '#161616', size: 5.5, days: 3 }),
        T('schedule', 68, 48, 32, 42, { bg: '#1b1b1b', size: 2.8 }),
        T('ticker', 0, 90, 100, 10),
    ],
};
export function layoutFromTemplate(name, bg = '#000') {
    const t = TEMPLATES[name];
    if (!t)
        throw new Error(`Unbekannte Vorlage ${name}`);
    return { specVersion: 2, bg, elements: t() };
}
// ---------- MVP-Zonenvorlagen (specVersion 1) ----------
const L = (de, en) => ({ de, en });
const W = 1920;
const H = 1080;
const land = (zones, fields, color = '#0B1F3A') => ({
    specVersion: 1, refWidth: W, refHeight: H, orientation: 'landscape', background: { color }, fonts: ['Inter'], zones, fields,
});
const port = (zones, fields, color = '#0B1F3A') => ({
    specVersion: 1, refWidth: H, refHeight: W, orientation: 'portrait', background: { color }, fonts: ['Inter'], zones, fields,
});
const txt = (size, weight = 800, color = '#FFFFFF', extra = {}) => ({ font: 'Inter', weight, size, color, align: 'left', ...extra });
/** Mindestens 8 globale Vorlagen ab Werk (DQ-STU-002). */
export const ZONE_TEMPLATES = [
    {
        id: 'tpl-fullscreen',
        name: L('Vollbild-Medium', 'Full-screen media'),
        layout: land([{ id: 'hero', type: 'media', x: 0, y: 0, w: W, h: H, z: 1, fit: 'cover' }], [{ zone: 'hero', label: L('Bild oder Video', 'Image or video'), required: true }], '#000000'),
    },
    {
        id: 'tpl-media-title',
        name: L('Medium + Titelzeile', 'Media + title bar'),
        layout: land([
            { id: 'hero', type: 'media', x: 0, y: 0, w: W, h: 900, z: 1, fit: 'cover' },
            { id: 'title', type: 'text', x: 64, y: 920, w: 1792, h: 140, z: 2, style: txt(80, 800, '#FFFFFF', { maxLines: 1, autoShrink: true }) },
        ], [
            { zone: 'hero', label: L('Bild oder Video', 'Image or video'), required: true },
            { zone: 'title', label: L('Titel', 'Title'), maxLength: 60, required: true },
        ]),
    },
    {
        id: 'tpl-split',
        name: L('50/50', '50/50'),
        layout: land([
            { id: 'left', type: 'media', x: 0, y: 0, w: 960, h: H, z: 1, fit: 'cover' },
            { id: 'right', type: 'media', x: 960, y: 0, w: 960, h: H, z: 1, fit: 'cover' },
        ], [
            { zone: 'left', label: L('Links', 'Left'), required: true },
            { zone: 'right', label: L('Rechts', 'Right'), required: true },
        ], '#000000'),
    },
    {
        id: 'tpl-sidebar',
        name: L('Seitenleiste rechts 30 %', 'Right sidebar 30 %'),
        layout: land([
            { id: 'main', type: 'media', x: 0, y: 0, w: 1344, h: H, z: 1, fit: 'cover' },
            { id: 'side', type: 'media', x: 1344, y: 0, w: 576, h: H, z: 1, fit: 'cover', source: 'playlist' },
        ], [
            { zone: 'main', label: L('Hauptbereich', 'Main area'), required: true },
            { zone: 'side', label: L('Seitenleiste (Bilder)', 'Sidebar (images)') },
        ], '#000000'),
    },
    {
        id: 'tpl-offer',
        name: L('Angebot', 'Offer'),
        layout: land([
            { id: 'hero', type: 'media', x: 0, y: 0, w: 1152, h: H, z: 1, fit: 'cover' },
            { id: 'title', type: 'text', x: 1200, y: 120, w: 672, h: 260, z: 2, style: txt(96, 800, '#FFFFFF', { maxLines: 2, autoShrink: true }) },
            { id: 'price', type: 'text', x: 1200, y: 420, w: 672, h: 140, z: 2, style: txt(120, 800, '#14B8A6') },
            { id: 'subtitle', type: 'text', x: 1200, y: 600, w: 672, h: 300, z: 2, style: txt(48, 400, '#E2E8F0', { maxLines: 4 }) },
            { id: 'logo', type: 'logo', x: 1700, y: 960, w: 180, h: 80, z: 3, fit: 'contain' },
        ], [
            { zone: 'hero', label: L('Bild oder Video', 'Image or video'), required: true },
            { zone: 'title', label: L('Titel', 'Title'), maxLength: 60, required: true },
            { zone: 'price', label: L('Preis', 'Price'), maxLength: 20 },
            { zone: 'subtitle', label: L('Untertitel', 'Subtitle'), maxLength: 140 },
        ]),
    },
    {
        id: 'tpl-infoscreen',
        name: L('Infoscreen', 'Info screen'),
        layout: land([
            { id: 'logo', type: 'logo', x: 64, y: 48, w: 360, h: 140, z: 2, fit: 'contain' },
            { id: 'clock', type: 'clock', x: 1456, y: 48, w: 400, h: 140, z: 2, style: { format: 'HH:mm', color: '#FFFFFF', size: 96, align: 'right' } },
            { id: 'title', type: 'text', x: 64, y: 260, w: 1792, h: 180, z: 2, style: txt(110, 800, '#FFFFFF', { maxLines: 1, autoShrink: true }) },
            { id: 'body', type: 'text', x: 64, y: 480, w: 1792, h: 540, z: 2, style: txt(56, 400, '#E2E8F0', { maxLines: 7, autoShrink: true }) },
        ], [
            { zone: 'title', label: L('Titel', 'Title'), maxLength: 60, required: true },
            { zone: 'body', label: L('Text', 'Text'), maxLength: 600 },
        ]),
    },
    {
        id: 'tpl-portrait-poster',
        name: L('Hochformat-Poster', 'Portrait poster'),
        layout: port([
            { id: 'hero', type: 'media', x: 0, y: 0, w: H, h: 1440, z: 1, fit: 'cover' },
            { id: 'title', type: 'text', x: 64, y: 1480, w: 952, h: 240, z: 2, style: txt(96, 800, '#FFFFFF', { maxLines: 2, autoShrink: true }) },
            { id: 'subtitle', type: 'text', x: 64, y: 1740, w: 952, h: 140, z: 2, style: txt(48, 400, '#E2E8F0', { maxLines: 2 }) },
        ], [
            { zone: 'hero', label: L('Bild oder Video', 'Image or video'), required: true },
            { zone: 'title', label: L('Titel', 'Title'), maxLength: 60, required: true },
            { zone: 'subtitle', label: L('Untertitel', 'Subtitle'), maxLength: 100 },
        ]),
    },
    {
        id: 'tpl-portrait-menu',
        name: L('Hochformat-Menü', 'Portrait menu'),
        layout: port([
            { id: 'title', type: 'text', x: 64, y: 80, w: 952, h: 200, z: 2, style: txt(110, 800, '#FFFFFF', { maxLines: 1, autoShrink: true }) },
            ...[1, 2, 3, 4, 5, 6].map((n) => ({
                id: `line${n}`, type: 'text', x: 64, y: 300 + (n - 1) * 240, w: 952, h: 200, z: 2,
                style: txt(64, 600, '#FFFFFF', { maxLines: 2, autoShrink: true }),
            })),
            { id: 'logo', type: 'logo', x: 760, y: 1780, w: 256, h: 100, z: 3, fit: 'contain' },
        ], [
            { zone: 'title', label: L('Titel', 'Title'), maxLength: 40, required: true },
            ...[1, 2, 3, 4, 5, 6].map((n) => ({ zone: `line${n}`, label: L(`Zeile ${n}`, `Line ${n}`), maxLength: 60 })),
        ]),
    },
];
//# sourceMappingURL=templates.js.map